var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104.211,
    height: 104.211,
    rx: 52.1053,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 104.211,
    height: 104.211,
    rx: 52.1053,
    stroke: "#2F91F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5889 34.5198C28.3557 34.5198 25.7271 37.1484 25.7271 40.3816V46.2435C25.7271 47.0495 26.4048 47.6814 27.165 47.9471C28.8869 48.5424 30.1234 50.1819 30.1234 52.1053C30.1234 54.0287 28.8869 55.6682 27.165 56.2635C26.4048 56.5292 25.7271 57.1611 25.7271 57.9671V63.829C25.7271 67.0622 28.3557 69.6908 31.5889 69.6908H72.6218C75.855 69.6908 78.4836 67.0622 78.4836 63.829V57.9671C78.4836 57.1611 77.8059 56.5292 77.0456 56.2635C75.3237 55.6682 74.0872 54.0287 74.0872 52.1053C74.0872 50.1819 75.3237 48.5424 77.0456 47.9471C77.8059 47.6814 78.4836 47.0495 78.4836 46.2435V40.3816C78.4836 37.1484 75.855 34.5198 72.6218 34.5198H31.5889ZM37.4507 44.778V59.4326C37.4507 60.2386 38.1102 60.8981 38.9162 60.8981H65.2945C66.1005 60.8981 66.7599 60.2386 66.7599 59.4326V44.778C66.7599 43.972 66.1005 43.3125 65.2945 43.3125H38.9162C38.1102 43.3125 37.4507 43.972 37.4507 44.778ZM34.5198 43.3125C34.5198 41.6914 35.8296 40.3816 37.4507 40.3816H66.7599C68.3811 40.3816 69.6909 41.6914 69.6909 43.3125V60.8981C69.6909 62.5192 68.3811 63.829 66.7599 63.829H37.4507C35.8296 63.829 34.5198 62.5192 34.5198 60.8981V43.3125Z",
    fill: "#2F91F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconlogo);
export default __webpack_public_path__ + "static/media/iconlogo.5c3026c1c2dc3d292f1afef6c1ef2ea2.svg";
export { ForwardRef as ReactComponent };